export default "__VITE_ASSET__58b5318a__"